module.exports = __webpack_public_path__ + "img/1.c1967369.jpg";